export const screens = {
  desktop: '1024px',
};
